import { useCallback, useMemo } from 'react'

import { Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import isNil from 'lodash.isnil'

import { getNumberOfDaysForMonth } from 'src/utils/date'

type Props = {
  isDisabled?: boolean
  month: number | undefined
  onValueChange: (value: number | undefined) => void
  value: number | undefined
}
const DaySelect = ({ isDisabled, month, onValueChange, value }: Props) => {
  const numberOfDays = !isNil(month) ? getNumberOfDaysForMonth(month) : 0

  const options: SelectOption<number>[] = useMemo(
    () =>
      new Array(numberOfDays).fill(0).map((_, index) => ({
        label: `${index + 1}`,
        value: index + 1,
      })),
    [numberOfDays]
  )

  const handleSelectedOptionChange = useCallback(
    (newSelectedOption?: SelectOption<number>) => {
      onValueChange(newSelectedOption?.value)
    },
    [onValueChange]
  )

  return (
    <Select
      ariaLabel="Day"
      getOptionKey={(o) => o.value}
      options={options}
      onSelectedOptionChange={handleSelectedOptionChange}
      selectedOption={options.find((o) => o.value === value)}
      width="85px"
      isDisabled={isNil(month) || isDisabled}
      placeholder="Day"
    />
  )
}

export default React.memo(DaySelect)
